// @flow
// типы паролей при логине
export const PASSWORD_PERMANENT: 'perm' = 'perm';
export const PASSWORD_TEMPORARY: 'temp' = 'temp';
export const PASSWORD_EMPTY: null = null;
